import Account from "./views/Account.vue";

const route = [
  {
    path: "/mon-compte",
    name: "account",
    component: Account,
    meta: {
      layout: "default",
      auth: true,
      role: ["A", "R"]
    }
  }
];

export default route;
